<template>
    <div class="ch-container">
        <div v-if="isTeacher" class="flex items-center flex-grow mb-base">
          <vs-select v-if="hasManyGroups" v-model="selectedGroup" class="mr-4 vs-input-shadow-drop vs-select-no-border d-theme-input-dark-bg w-48">
            <vs-select-item value="0" text="كل المجموعات" />
            <vs-select-item v-for="(group, index) in getCourseDetails.groups" :key="index" :value="group.group" :text="group.group" />
          </vs-select>
          <vs-button class="ml-auto" @click="showLectureForm = true" color="success" icon-pack="feather" icon="icon-plus" icon-after >محاضرة جديدة</vs-button>
        </div>
        <div v-if="teacherLectures.length > 0" class="lectures vx-row">
            <div v-for="lecture in lectures" :key="lecture.id"
                 class="vx-col mb-base w-full">
              <lecture-item :lecture="lecture"/>
            </div>
        </div>
        <div v-else class="mt-8 text-center">
          <img class="w-full mb-base max-w-xs" src="@/assets/images/svg/no-data.svg" alt="quizzes.svg">
          <h2 class="text-left text-primary mb-2">لا يوجد محاضرات</h2>
          <h5 class="text-left">
            <span v-if="isTeacher">يمكنك إضافة محاضرة جديد عن طريق الضغط علي زر محاضرة جديد</span>
            <span v-if="isStudent">قم بالتحقق لاحقاً عندما يقوم الاستاذ بإضافة محاضرة</span>
          </h5>
        </div>
        <lecture-form v-if="isTeacher" @submit="saveLecture" :active.sync="showLectureForm"/>
    </div>
</template>
<script>
    import lectureForm from './LectureForm'
    import lecturesAPI from "@/api/lecturesAPI"
    import LectureItem from '@/views/course/lectures/lectureItem'

    export default {
        data() {
            return {
                course_id: this.$route.params.course_id,
                showLectureForm: false,
                teacherLectures: [],
                selectedGroup: 0,
                editorOption: {
                    modules: {
                        toolbar: '#toolbar'
                    },
                    placeholder: 'محتوى المحاضرة'
                },
                settings: {
                    maxScrollbarLength: 20,
                },
            }
        },
        computed: {
            lectures() {
                let lectures =  this.teacherLectures.filter(lecture => {
                        return lecture.groups ? lecture.groups.includes(this.selectedGroup) || this.selectedGroup == 0 : true
                    })
                return lectures.sort((first, second) => {
                    return new Date(second.date) - new Date(first.date)
                })
            }
        },
        methods: {
            saveLecture(lecture){
                this.teacherLectures.push(lecture)
                this.$router.push({name: 'courseLecture', params: {lecture_id: lecture.id}})
            },
            setLectures(lectures){
                this.teacherLectures = lectures.map(lecture => {
                    if (lecture.body.length > 150){
                        lecture.body = lecture.body.substring(0, 150) + '...'
                    }
                    return lecture
                })
            }
        },
        components: {
            LectureItem,
            lectureForm,
        },
        beforeRouteEnter(to, from, next){
            lecturesAPI.setCourseId(to.params.course_id)
            lecturesAPI.getAll()
                .then(({data}) => {
                    next(vm => vm.setLectures(data.lectures))
                })
                .catch(error => {if(error.status === 404) next('/not-found-404')})
        },
    }
</script>
